const GridCardLandingSkeleton = () => {
  return (
    <div className="rounded-8 border  bg-fds-primary border-fds-cart hover:shadow-brand-md sm:p-3  flex flex-col  p-2">
      <div className="w-full h-36 bg-fds-secondary" />
      <div className="mt-2  w-full h-6  bg-fds-secondary mb-px" />
      <div className="mt-2  w-1/2  h-6  bg-fds-secondary mb-px" />

      <div className="flex flex-col gap-y-1.5  mt-3">
        <div className="flex items-center gap-x-0.5 ">
          <div className="h-5    w-5    bg-fds-secondary" />
          <div className="h-5    w-20 bg-fds-secondary" />
        </div>
        <div className="flex items-center gap-x-0.5 ">
          <div className="h-5    w-5    bg-fds-secondary" />
          <div className="h-5    w-20 bg-fds-secondary" />
        </div>
      </div>
      <div className="w-40 h-5    bg-fds-secondary my-2" />
    </div>
  );
};

export default GridCardLandingSkeleton;
